import { createSelector } from 'reselect'

import { selectQbrState } from './selectQbrState'

export const selectQbrCurrentFYear = createSelector(
  [selectQbrState],
  ({ documentSettings }) => documentSettings.currentFYear
)
